import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Icon } from '@unite-us/ui';
var variantStyles = {
  warning: {
    colors: 'border-yellow bg-light-yellow',
    dismissIconColor: 'text-text-blue',
    icon: 'IconExclamationCircle',
    iconColor: 'text-yellow',
    contentTextColor: 'text-text-blue'
  }
};
var Banner = function Banner(_ref) {
  var variant = _ref.variant,
    content = _ref.content,
    onDismiss = _ref.onDismiss;
  var styles = useMemo(function () {
    return variantStyles[variant];
  }, [variant]);
  return /*#__PURE__*/React.createElement("div", {
    className: classNames('flex justify-between items-center h-52px px-6 rounded border border-solid', styles.colors)
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex justify-start items-center gap-2"
  }, /*#__PURE__*/React.createElement(Icon, {
    icon: styles.icon,
    className: classNames('fill-current', styles.iconColor),
    size: 24
  }), /*#__PURE__*/React.createElement("div", {
    className: styles.contentTextColor
  }, content)), /*#__PURE__*/React.createElement("button", {
    onClick: onDismiss
  }, /*#__PURE__*/React.createElement(Icon, {
    icon: "IconCross",
    className: classNames('fill-current', styles.dismissIconColor),
    size: 16
  })));
};
Banner.propTypes = {
  variant: PropTypes.oneOf(['warning']).isRequired,
  content: PropTypes.node.isRequired,
  onDismiss: PropTypes.func.isRequired
};
export default Banner;